import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=4e45d744&scoped=true"
import script from "./Service.vue?vue&type=script&lang=js"
export * from "./Service.vue?vue&type=script&lang=js"
import style0 from "./Service.vue?vue&type=style&index=0&id=4e45d744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e45d744",
  null
  
)

export default component.exports